import React, { useState } from "react";
import RoleToggle from "../../components/RoleToggle";
import LocationTab from "./_components/TicketsTab";
import ChatSupportListTab from "./_components/ChatSupportListTab";

const HelpandSupport: React.FC = () => {
  const [activeRole, setActiveRole] = useState("Tickets");
  const roles = ["Tickets", "Chat Support"];
  return (
    <>
      <div className="p-6 pt-0 space-y-4">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl text-[#212121] tracking-[-0.5px] ">
            Help & Support
          </h1>
          <RoleToggle
            options={roles}
            active={activeRole}
            onChange={setActiveRole}
          />
        </div>

        {activeRole === "Tickets" ? <LocationTab /> : null}
        {activeRole === "Chat Support" ? <ChatSupportListTab /> : null}
      </div>
    </>
  );
};

export default HelpandSupport;
